import { LabelType } from './label-type';
import { PrintJobDto, PrintJobStatus } from './print-job.dto';

/** The subset of `PrintJobDto` the log reads — see `api-contract.md` for what stays on the wire. */
export class PrintJob {
    readonly id: string;
    readonly printerName: string;
    readonly labelType: LabelType;
    readonly subjectCode: string;
    readonly status: PrintJobStatus;
    readonly attempts: number;
    readonly error: string;
    readonly errorCode: string;
    readonly iteration: number;
    readonly stationCode: string;
    readonly createdAt: Date;

    constructor(dto: PrintJobDto) {
        this.id = dto.id;
        this.printerName = dto.printerName ?? '';
        this.labelType = dto.labelType;
        this.subjectCode = dto.subjectCode;
        this.status = dto.status;
        this.attempts = dto.attempts;
        this.error = dto.error ?? '';
        this.errorCode = dto.errorCode ?? '';
        this.iteration = dto.iteration;
        this.stationCode = dto.stationCode ?? '';
        this.createdAt = new Date(dto.createdAt);
    }
}
